import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

interface CompareValueCellProps {
    isHighlighted: boolean;
    value: string;
}

const Wrapper = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
    display: flex;
    justify-content: right;
`;

const HighlightedValue = styled.span<{ isHighlighted: boolean }>`
    align-self: center;
    font-weight: ${({ isHighlighted }) => (isHighlighted ? 600 : 400)};
`;

export const CompareValueCell = ({ isHighlighted, value }: CompareValueCellProps) => {
    return (
        <Wrapper>
            <HighlightedValue isHighlighted={isHighlighted}>{value}</HighlightedValue>
        </Wrapper>
    );
};
